var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-px-2 tw-py-1 tw-inline-flex tw-border tw-rounded-full tw-font-semibold tw-text-thin",style:({ background: _vm.backgroundColour, color: '#ffffff' }),attrs:{"data-cy":"leave-type-name"}},[_vm._v(" "+_vm._s(_vm.leaveTypeLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }